import { ACCEPT_TRADE_OFFER, FETCH_TRADE_OFFERS, REJECT_TRADE_OFFER, SEND_MESSAGE, CANCEL_TRADE_REQUEST } from '../constants/tradeOffersTypes';

export function sendMessage(params) {
  return {
    type: SEND_MESSAGE,
    payload: params
  };
}

export function fetchTradeOffers(params) {
  return {
    type: FETCH_TRADE_OFFERS,
    payload: params
  };
}

export function acceptTradeOffer(params) {
  return {
    type: ACCEPT_TRADE_OFFER,
    payload: params
  };
}

export function rejectTradeOffer(params) {
  return {
    type: REJECT_TRADE_OFFER,
    payload: params
  };
}

export function cancelTradeRequest(params) {
  return {
    type: CANCEL_TRADE_REQUEST,
    payload: params
  }
}



// WEBPACK FOOTER //
// ./app/actions/tradeOffersActions.js